package com.veldekar.pages.log

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.veldekar.components.layouts.SessionPageLayout
import com.veldekar.components.logs.Log_2024_05_10_Day_1
import com.veldekar.components.widgets.SessionDayHeader
import kotlinx.datetime.LocalDate

@Page(routeOverride = "/2024-05-10")
@Composable
public fun Log_2024_05_10(ctx: PageContext) {
    SessionPageLayout(
        ctx = ctx,
        title = "Yochlol and Ropers",
        ogTitle = "Yochlol and Ropers",
        date = LocalDate(2_024, 5, 10),
        ogDescription = "Deeper in the cavern, the party faces Yochlol demons and Ropers in a sound-dampened environment.",
        ogImage = "ai/2024-05-10.webp",
        ogImageWidth = 1_200,
        ogImageHeight = 630,
    ) {
        SessionDayHeader(dayId = "newgrowth-52", dateString = "Newgrowth 52")
        Log_2024_05_10_Day_1()
    }
}
